import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { ProductPageConfig } from "../../productPage.config";
import { InfoBlockHeading } from "../productInfo/components/infoBlockHeading.component";
import { RelatedProductsSliderComponent } from "./relatedProductsSlider.component";

type RelatedProductsSliderProps = {
    productSource:
        | ProductSliderSources.MainProduct
        | ProductSliderSources.Accessory;
};

const _RelatedProductsSlider = ({
    productSource
}: RelatedProductsSliderProps) => {
    const { t } = useGranite();
    const { product, sliders } = useProductPageContext();
    const { breakpoints } = useBreakpoint();
    const [showMobileMore, setShowMobileMore] = useState(false);

    const title =
        productSource === ProductSliderSources.MainProduct
            ? t("sliders.mainProducts.title")
            : productSource === ProductSliderSources.Accessory
              ? t("sliders.accessories.title")
              : "";

    const breakpointLayoutSettings = ProductPageConfig.sliders.relatedProducts;

    useEffect(() => {
        setShowMobileMore(!!breakpoints?.lg);
    }, [breakpoints?.lg]);

    if (!sliders?.[productSource]) {
        return null;
    }

    return (
        <section
            id={"related-products-slider"}
            className={cn(
                `related-products-slider info-block js-info-block js-anchor-scroll-spy__block`,
                showMobileMore ? "info-block--active" : ""
            )}
        >
            <InfoBlockHeading
                title={title}
                onClick={() => setShowMobileMore((state) => !state)}
            />
            <RelatedProductsSliderComponent
                sku={product.sku}
                serverSideProducts={sliders?.[productSource]}
                productSource={productSource}
                title={breakpoints.lg ? title : ""}
                breakpointsLayoutSettings={breakpointLayoutSettings}
            />
        </section>
    );
};

export const RelatedProductsSlider = withBreakpoints(_RelatedProductsSlider);
